import React from 'react';

import { Divider } from '@/components/shared/element/divider';
import { Icon } from '@/components/shared/element/icons';
import { Link } from '@/components/shared/element/link';
import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Container } from '@/components/shared/layout/container';
import { Flex } from '@/components/shared/layout/flex';
import { styled } from '@/stitches.config';

const BreadcrumbStyled = styled(Flex, {
  minHeight: '$size-12',
  py: '$space-3',
  '@md': {
    minHeight: '$size-16',
  },
  '& li': {
    '&:not(:first-child):not(:last-child)': {
      '& > *:first-child': {
        '@md': {
          display: 'none',
        },
      },
      '& > a': {
        '@maxmd': {
          display: 'none',
        },
      },
    },
  },
});

export interface BreadcrumbProps {
  css?: any;
  className?: string;
  items: {
    label?: string;
    url?: string;
  }[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  css,
  className,
  items = [],
  ...rest
}: BreadcrumbProps) => {
  return (
    <Box css={css} className={className} test={{ dataTest: 'breadcrumb' }}>
      <Container>
        <BreadcrumbStyled alignItems="center" {...rest}>
          <Flex
            alignItems="baseline"
            columnGap="2"
            rowGap="1"
            css={{ overflow: 'hidden' }}
          >
            {items.map((item, index) => (
              <React.Fragment key={index}>
                {item.url ? (
                  <Flex as="li" alignItems="center" columnGap="2">
                    {index > 0 && (
                      <Text
                        size="text-button-2"
                        font="bold"
                        noWrap
                        line-height="150"
                        data-test="breadcrumb_label"
                        css={{
                          marginBottom: '-$space-0-5',
                        }}
                      >
                        ...
                      </Text>
                    )}
                    <Link
                      hoverColor="red"
                      href={item.url}
                      test={{
                        dataTest: 'breadcrumb_link',
                      }}
                    >
                      <Text
                        size="text-button-2"
                        font="bold"
                        noWrap
                        line-height="150"
                        data-test="breadcrumb_label"
                        css={{
                          marginBottom: '-$space-0-5',
                        }}
                      >
                        {item.label}
                      </Text>
                    </Link>
                    <Icon icon="chevron-right" />
                  </Flex>
                ) : (
                  <Text
                    as="li"
                    size="text-button-2"
                    font="bold"
                    line-height="150"
                    lines="1"
                    data-test="breadcrumb_label"
                    css={{
                      alignSelf: 'center',
                      marginBottom: '-$space-0-5',
                    }}
                  >
                    {item.label}
                  </Text>
                )}
              </React.Fragment>
            ))}
          </Flex>
        </BreadcrumbStyled>
        <Divider />
      </Container>
    </Box>
  );
};

Breadcrumb.displayName = 'Breadcrumb';
